import React from "react";
import { Paper } from "@mui/material";

const BasePaper = ({ children, sx = {}, ...props }) => (
  <Paper
    elevation={6}
    sx={{
      padding: 4,
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      borderRadius: 3,
      ...sx,
    }}
    {...props}
  >
    {children}
  </Paper>
);

export default BasePaper;
